module.exports = "<router-outlet style=\"padding-top: 20px\"></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/container/content/content.component.html
// module id = ./src/app/container/content/content.component.html
// module chunks = main